import { Card, Table } from "@caprikorn/dynamo-ui";
import type { FC } from "react";
import { useParams } from "react-router-dom";

import type { UrlParam } from "@router/router.types";
import type { GetExpositionPoint } from "@services/apiEcms/apiEcms.types";
import { useGetExpositionPoint } from "@services/apiEcms/useGetExpositionPoint";
import { useGetMaximalPower } from "@services/apiEcms/useGetMaximalPower";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import { usePerimeterSiteMaxPowerColumns } from "./PerimeterSiteMaxPower.columns";
import classes from "./PerimeterSiteMaxPower.module.css";

const selectSubscribedMaximalPower = ({
  subscribedMaximalPower,
}: GetExpositionPoint) => subscribedMaximalPower;

export const PerimeterSiteMaxPower: FC = () => {
  const { t } = useCustomTranslation("main");
  const {
    customerId = "",
    contractId = "",
    siteId = "",
  } = useParams<UrlParam>();

  const {
    data: maximalPowers,
    isError: isMaximalPowersError,
    isLoading: isMaximalPowersLoading,
  } = useGetMaximalPower({ customerId, contractId, siteId });

  const { data: subscribedMaximalPower } = useGetExpositionPoint(
    { customerId, contractId, siteId },
    {
      select: selectSubscribedMaximalPower,
    },
  );

  const columns = usePerimeterSiteMaxPowerColumns();

  return (
    <Card className={classes.card} data-testid="PerimeterSiteMaxPower-Card">
      <div>
        <h3 className="font-title-lg">
          {t("perimeter.sites.maximalPower.title")}
        </h3>
        {subscribedMaximalPower && (
          <p className="font-paragraph-default">
            {t("perimeter.sites.subscribedPower", {
              value: subscribedMaximalPower,
            })}
          </p>
        )}
      </div>

      <Table
        columns={columns}
        data={maximalPowers || []}
        isError={isMaximalPowersError}
        isLoading={isMaximalPowersLoading}
        noPagination
      >
        <Table.Content />
      </Table>
    </Card>
  );
};
